import Vue from 'vue'
import router from './router'
import store from './store'

import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import notification from 'ant-design-vue/es/notification'
import { setDocumentTitle, domTitle } from '@/utils/domUtil'
import { ACCESS_TOKEN,TOP_ACTIVE_MENU } from '@/store/mutation-types'
import i18n from './locales'
NProgress.configure({ showSpinner: false }) // NProgress Configuration
let vueObj = new Vue({
  i18n
})
const whiteList = ['login', 'register', 'registerResult','inductionOut'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  console.log(to.meta.title)
  localStorage.setItem("preUrl",from.fullPath);
  to.meta && (typeof to.meta.title !== 'undefined' && setDocumentTitle(`${vueObj.$t(to.meta.title)} - ${domTitle}`))
  if(from.path === '/user/login'){
    next()
    NProgress.done()
  }
  if (Vue.ls.get(ACCESS_TOKEN)) {
    /* has token */
    if (to.path === '/user/login') {
      next({ path: '/' })
      NProgress.done()
    }else if(whiteList.includes(to.name)){
        next()
        NProgress.done()
    } else {
      if (store.getters.roles.length === 0) {
        store
          .dispatch('GetInfo')
          .then(res => {
            const roles = res.data && res.data.role
            const resource = res.data && res.data.resource
            if(!resource){
              notification.error({
                message: '警告',
                description: '没有配置伙伴角色或资源信息,请先配置伙伴角色或资源信息!'
              })
              store.dispatch('Logout').then(() => {
                next({ path: '/user/login', query: { redirect: to.fullPath } })
              })
              return;
            }
            store.dispatch('GenerateRoutes', { resource }).then(() => {
              // 根据roles权限生成可访问的路由表
              // 动态添加可访问路由表
              router.addRoutes(store.getters.addRouters)
              let active = Vue.ls.get(TOP_ACTIVE_MENU)
              if(active == null){
                next({ path: to.path })
              }else {
                if(to.query != null){
                  next({ path: to.path, query: to.query})
                }else{
                  next({ path: to.path })
                }

                // const redirect = decodeURIComponent(from.query.redirect || to.path)
                // if (to.path === redirect) {
                //   // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                //   next({ ...to, replace: true })
                // } else {
                //   // 跳转到目的路由
                //   next({ path: redirect })
                // }
              }
            })
          })
          .catch(() => {
            notification.error({
              message: '提示',
              description: '太久没有操作,登录已失效,请重新登录'
            })
            store.dispatch('Logout').then(() => {
              next({ path: '/user/login', query: { redirect: to.fullPath } })
            })
          })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.includes(to.name)) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next({ path: '/user/login', query: { redirect: to.fullPath } })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  console.log("跳转到顶部去")
  document.getElementById("app").scrollTop = 0;
  NProgress.done() // finish progress bar
})
